import { useIsPlanType } from '../use-is-plan-type';

const useBandwidthWidget = (): boolean => {
  const { isEnterprise, isEnterprise4k, isPro, isProLegacyEmbedOnly, isStarterLegacy, isStarterLite, isUBP } =
    useIsPlanType();

  return (
    (isEnterprise || isEnterprise4k || isPro || isProLegacyEmbedOnly || isStarterLegacy || isStarterLite) && !isUBP
  );
};

export default useBandwidthWidget;
